import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import Accommodations from '../../components/vehicles/edit-vehicle/Accommodations'
import {
  actionCreators,
  getAccommodations,
  getSingleVehicle,
  updateVehicleAccommodations
} from '../../state/actions/vehicles'
import { ISaveVehicleAccommodations, IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<{ id: string }>) {
  return {
    ...ownProps,
    accommodations: Object.values(state.vehicles.vehicleAccommodations),
    requesting: state.vehicles.vehicleAccommodationsRequest,
    error: state.vehicles.createEditVehicleFail,
    isSaved: state.vehicles.isSaved,
    isRequesting: state.vehicles.isLoading,
    currentVehicle: state.vehicles.items[ownProps.match.params.id]
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    getAccommodations: () => dispatch(getAccommodations()),
    updateVehicleAccommodations: (data: ISaveVehicleAccommodations) => dispatch(updateVehicleAccommodations(data)),
    getVehicleById: (id: string) => dispatch(getSingleVehicle(id)),
    setVehicleSavedStateToInitial: () => dispatch(actionCreators.setVehicleSavedStateToInitial())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Accommodations)



// WEBPACK FOOTER //
// ./src/containers/vehicles/Accomodations.ts